export default __webpack_public_path__ + "static/media/shield.8b79e33b.svg";